import { render, staticRenderFns } from "./event-edit.vue?vue&type=template&id=52495300&scoped=true"
import script from "./event-edit.vue?vue&type=script&lang=js"
export * from "./event-edit.vue?vue&type=script&lang=js"
import style0 from "./event-edit.vue?vue&type=style&index=0&id=52495300&prod&lang=scss&scoped=true"
import style1 from "./event-edit.vue?vue&type=style&index=1&id=52495300&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52495300",
  null
  
)

export default component.exports